/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetLlmUsageQueryResponse, GetLlmUsagePathParams, GetLlmUsage400, GetLlmUsage401, GetLlmUsage403, GetLlmUsage404, GetLlmUsage409, GetLlmUsage500 } from "../../types/platformBillingController/GetLlmUsage.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetLlmUsageUrl(organizationId: GetLlmUsagePathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/llm/usage` as const }
  return res
}

/**
 * @summary Get LLM usage summary
 * {@link /api/organizations/:organizationId/llm/usage}
 */
export async function getLlmUsage(organizationId: GetLlmUsagePathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLlmUsageQueryResponse, ResponseErrorConfig<GetLlmUsage400 | GetLlmUsage401 | GetLlmUsage403 | GetLlmUsage404 | GetLlmUsage409 | GetLlmUsage500>, unknown>({ method : "GET", url : getGetLlmUsageUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}